module.exports = __webpack_public_path__ + "img/updateimg03.692844cb.png";